/**
 * Search & Filter Pro v3 - Translate placeholders for Polylang
 *
 * S&F v3 renders via JavaScript/React, so PHP filters cannot modify its output.
 * This script uses a MutationObserver to detect when S&F fields are rendered
 * and swaps the placeholder/aria-label text using translations passed from PHP
 * via php_vars.sfTranslations.
 */

/**
 * Search & Filter Pro v3 - Translate placeholders for Polylang
 *
 * S&F v3 renders via JavaScript/React, so PHP filters cannot modify its output.
 * This script uses a MutationObserver to aggressively find and replace placeholder text
 * and optionally force default active selections.
 */

export function initSFTranslate() {
	if ( ! window.php_vars || ! window.php_vars.sfTranslations ) return;

	const translations = window.php_vars.sfTranslations;
	const currentLang  = window.php_vars.currentLang || 'en';
	
	function forceTranslateAndSelect() {
		// 1. Force Translate Placeholders and Labels
		document.querySelectorAll('input, [role="combobox"]').forEach(el => {
			const p = el.getAttribute('placeholder');
			if (p && translations[p] && translations[p] !== p) {
				el.setAttribute('placeholder', translations[p]);
			}
			const al = el.getAttribute('aria-label');
			if (al && translations[al] && translations[al] !== al) {
				el.setAttribute('aria-label', translations[al]);
			}
		});

		// 2. Translate "All" selection text in comboboxes
		document.querySelectorAll('.search-filter-component-combobox__selection').forEach(el => {
			// Skip if already translated to prevent React overwrite loops
			if (el.dataset.allTranslated === 'true') return;

			const text = el.textContent.trim();
			
			if (text === 'All' && translations['All']) {
				el.textContent = translations['All'];
				el.dataset.allTranslated = 'true';
			}
		});

		// 3. Force Default Selection if currently in French 
		// and no parameter is in the URL yet for 'timeframe'
		// It checks if S&F comboboxes exist.
		if ( currentLang === 'fr' && window.location.search.indexOf('_sft_') === -1 && window.location.search.indexOf('_sfm_') === -1 && window.location.search.indexOf('_timeframe') === -1 && window.location.search.indexOf('~1') === -1 ) {
			const activeSelections = document.querySelectorAll('.search-filter-component-combobox__selection');
			
			activeSelections.forEach(selection => {
				const container = selection.closest('.search-filter-component-combobox');
				if (container && !container.dataset.defaultSetInProgress) {
					const input = container.querySelector('input');
					// Identify the Timeframe field (it either has the specific placeholder or aria-label)
					const isTimeframe = input && (
						(input.getAttribute('aria-label') === 'Timeframe' || (translations['Timeframe'] && input.getAttribute('aria-label') === translations['Timeframe'])) ||
						(input.getAttribute('placeholder') === 'Upcoming / Past Events' || (translations['Upcoming / Past Events'] && input.getAttribute('placeholder') === translations['Upcoming / Past Events']))
					);

					// If we found the timeframe field and nothing is selected yet
					if (isTimeframe && selection.innerHTML.trim() === '') {
						
						const listboxId = input.getAttribute('aria-controls');
						if (listboxId) {
							// Find the option
							const option = document.querySelector(`#${listboxId} [data-option-value="a-venir"]`);
							if (option) {
								container.dataset.defaultSetInProgress = "true";
								// S&F v3 handles clicks on options to update state. 
								// In React, a native click() might not trigger the synthetic event handler reliably.
								const event = new MouseEvent('click', {
									view: window,
									bubbles: true,
									cancelable: true
								});
								option.dispatchEvent(event);
							}
						}
					}
				}
			});
		}
	}

	forceTranslateAndSelect();

	const observer = new MutationObserver((mutations) => {
		let run = false;
		for (let i = 0; i < mutations.length; i++) {
			if (mutations[i].addedNodes.length > 0 || mutations[i].type === 'attributes') {
				run = true;
				break;
			}
		}
		if (run) {
			forceTranslateAndSelect();
		}
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true,
		attributes: true,
		attributeFilter: ['placeholder', 'aria-label', 'class']
	});
}
